module.exports = __webpack_public_path__ + "static/media/plan-acumula-200-gigas.4395fe30.svg";